import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IField } from '@shared/model/basic-data';

@Injectable({
  providedIn: 'root',
})
export class RegistrationDataService {
  private _baseUrl: string = `${environment.apiUrl}/projects/project_company`;

  constructor(private _http: HttpClient) {}

  getRegistrationData(id: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/${id}/`);
  }

  updateRegistrationData(id: number, data: IField): Observable<any> {
    return this._http.patch(`${this._baseUrl}/${id}/`, {
      [data.name]: data.value,
    });
  }
}
